import { IObjectKeys } from "../events/interfaces/ObjectKeys";

export const unsupportedBrowser = (props:any) => {
    let result = false;
    let browserName = '';
    for(const p in props) {
        if (props[p]) {
            result = true;
            browserName = p.replace(/^is/,'').replace(/([a-z]{1})([A-Z]{1})/g, '$1 $2').trim();
            break;
        }
    }
    return {result, browserName};
};
const BrowserSupport = (props:IObjectKeys) => {
    const {result, browserName} = unsupportedBrowser(props);
    if (result) {
        return <div className="m-5">{browserName} is not supported. Download Chrome, Opera, Firefox or the latest Edge.</div>;
    }
    return null;
}

export default BrowserSupport;